import apiClient from './client';
import { API_ENDPOINTS } from '@/constants';

export const matchApi = {
  list: (params) => apiClient.get(API_ENDPOINTS.MATCHES.BASE, { params }),
  getById: (id) => apiClient.get(API_ENDPOINTS.MATCHES.BY_ID(id)),
  create: (data) => apiClient.post(API_ENDPOINTS.MATCHES.BASE, data),
  update: (id, data) => apiClient.put(API_ENDPOINTS.MATCHES.BY_ID(id), data),
  remove: (id) => apiClient.delete(API_ENDPOINTS.MATCHES.BY_ID(id)),
  start: (id, body) => apiClient.post(API_ENDPOINTS.MATCHES.START(id), body),
  end: (id) => apiClient.post(API_ENDPOINTS.MATCHES.END(id)),
};
